import React from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { I18n } from 'i18n';
import { useSelector } from 'react-redux';
import { Log } from '../../voltage-amperage/views/log';
import { GraphicPowerRange } from '../../voltage-amperage/views/historic-log';
import { GraphicPowerFilters } from '../../voltage-amperage/views/overview-daily-log';
import { GraphicDailyConsumption } from '../../voltage-amperage/views/daily';
import { GraphicWeeklyConsumption } from '../../voltage-amperage/views/weekly';
import { Sider, Main } from '../components';

const ROUTES = [
  {
    name: I18n('daily_graph', true),
    key: 'daily-graph',
    path: '/electric/voltage-and-amperage/daily-graph',
    component: GraphicPowerFilters,
  },
  {
    name: I18n('daily_graph_range', true),
    key: 'daily-graph-range',
    path: '/electric/voltage-and-amperage/daily-graph-range',
    component: GraphicPowerRange,
  },
  {
    name: I18n('data_table', true),
    key: 'table',
    path: '/electric/voltage-and-amperage/table',
    component: Log,
  },
  {
    name: I18n('daily_consumption', true),
    key: 'daily-consumption',
    path: '/electric/voltage-and-amperage/daily-consumption',
    component: GraphicDailyConsumption,
  },
  {
    name: I18n('weekly_consumption', true),
    key: 'weekly-consumption',
    path: '/electric/voltage-and-amperage/weekly-consumption',
    component: GraphicWeeklyConsumption,
  },
];

export function MenuVoltageAmperage() {
  const { collapseNav } = useSelector(({ app }) => app);
  const { pathname } = useLocation();
  const location = pathname.split('/');
  return (
    <Layout>
      {!collapseNav && (
        <Sider
          ROUTES={ROUTES}
          defaultSelectedKeys={location[3]}
          title={I18n('voltage_and_amperage', true)}
          key={'voltage_and_amperage'}
        />
      )}
      <Main ROUTES={ROUTES} collapseNav={collapseNav} breadcrumb={location} />
    </Layout>
  );
}
